module.exports = __webpack_public_path__ + "img/1bd49d0.webp";